export const BASE_URL = "https://data.realtorscrm.com/";


export const PROPERTY_IMAGES_URL = "https://data.realtorscrm.com/Images/";

export const AGENT_IMAGES_URL = "https://data.realtorscrm.com/AgentImages/";

export const AGENCY_LOGOS_URL = "https://data.realtorscrm.com/AgencyLogos/";

export const PROPERTY_PDFS_URL = "https://data.realtorscrm.com/pdfs/";
